import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IGetSearchedInterventionSuccessWithoutDataAction {
  message: string;
}

function getSearchedInterventionSuccessWithoutData(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IGetSearchedInterventionSuccessWithoutDataAction>,
) {
  draft.getSearchedIntervention.list = [];
  draft.getSearchedIntervention.config.isLoading = false;
  draft.getSearchedIntervention.config.emptyMsg = action.payload.message;
}

export default getSearchedInterventionSuccessWithoutData;
